/**
 * Décode les en-têtes d'email encodés en MIME (RFC 2047)
 * Exemple: =?utf-8?Q?Tr=C2=A0:_RE:_Due_diligence_?= -> Tr : RE: Due diligence ?
 */
export function decodeEmailHeader(header) {
  if (!header || typeof header !== 'string') {
    return header;
  }

  // Pattern pour détecter l'encodage MIME: =?charset?encoding?encoded-text?=
  const mimePattern = /=\?([^?]+)\?([BQbq])\?([^?]*)\?=/g;
  
  return header.replace(mimePattern, (match, charset, encoding, encodedText) => {
    try {
      if (encoding.toUpperCase() === 'Q') {
        // Quoted-Printable decoding
        return decodeQuotedPrintable(encodedText);
      } else if (encoding.toUpperCase() === 'B') {
        // Base64 decoding
        return decodeBase64(encodedText);
      }
    } catch (error) {
      console.warn('Erreur lors du décodage MIME:', error);
      return match; // Retourner le texte original en cas d'erreur
    }
    return match;
  });
}

/**
 * Décode le Quoted-Printable
 */
function decodeQuotedPrintable(text) {
  return text
    .replace(/_/g, ' ') // Les underscores représentent des espaces
    .replace(/=([0-9A-F]{2})/gi, (match, hex) => {
      return String.fromCharCode(parseInt(hex, 16));
    });
}

/**
 * Décode le Base64
 */
function decodeBase64(text) {
  try {
    return decodeURIComponent(escape(atob(text)));
  } catch (error) {
    console.warn('Erreur lors du décodage Base64:', error);
    return text;
  }
}

/**
 * Formate une date pour l'affichage
 */
export function formatDate(dateString) {
  if (!dateString) return 'N/A';
  
  return new Date(dateString).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

/**
 * Formate une date longue pour l'affichage détaillé
 */
export function formatLongDate(dateString) {
  if (!dateString) return 'Non spécifiée';
  
  return new Date(dateString).toLocaleDateString('fr-FR', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

/**
 * Obtient la classe CSS pour le badge de sentiment
 */
export function getSentimentBadge(sentiment) {
  const badges = {
    positive: { class: 'bg-success', icon: 'bi-emoji-smile', text: 'Positif' },
    negative: { class: 'bg-danger', icon: 'bi-emoji-frown', text: 'Négatif' },
    neutral: { class: 'bg-secondary', icon: 'bi-emoji-neutral', text: 'Neutre' }
  };
  return badges[sentiment] || badges.neutral;
}

/**
 * Détecte si le contenu est du HTML
 */
export function isHtmlContent(content) {
  if (!content || typeof content !== 'string') return false;
  
  return content.includes('<html>') || 
         content.includes('<body>') || 
         content.includes('<div>') ||
         content.includes('<p>') ||
         content.includes('<br>') ||
         content.includes('<span>');
}